/**
 * @generated SignedSource<<5ae7d0cf68db456b58e92d3057e392bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NavSectionKind = "custom" | "products" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ChannelsNavSectionFragment$data = {
  readonly id: string;
  readonly kind: NavSectionKind;
  readonly title: string;
  readonly viewerExternalChannelIds: ReadonlyArray<string>;
  readonly " $fragmentSpreads": FragmentRefs<"ChannelsAppsSidebarList_NavSectionPaginationFragment" | "ChannelsProductsSidebarList_NavSectionPaginationFragment">;
  readonly " $fragmentType": "ChannelsNavSectionFragment";
};
export type ChannelsNavSectionFragment$key = {
  readonly " $data"?: ChannelsNavSectionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChannelsNavSectionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChannelsNavSectionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerExternalChannelIds",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChannelsAppsSidebarList_NavSectionPaginationFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChannelsProductsSidebarList_NavSectionPaginationFragment"
    }
  ],
  "type": "NavSection",
  "abstractKey": null
};

(node as any).hash = "d497cf6599daaa2686560a927b68ed30";

export default node;
